<template>
  <div style="padding:20px;">
    <el-row :gutter="20">
      <el-row style="margin-bottom: 10px;">
        <el-button type="primary" size="mini" @click="getList()">查询</el-button>
        <el-button type="primary" size="mini" @click="homeConfig()">首页配置</el-button>
        <el-button type="primary" size="mini" @click="createModule()">添加版块</el-button>
      </el-row>

      <el-table :data="listData" style="width: 100%" border size="mini" v-loading="listLoading">
        <el-table-column prop="id" label="ID" width="90"></el-table-column>
        <el-table-column prop="module_type_name" label="版块名称"></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column label="排序" width="100">
          <template slot-scope="{ row }">
            <template v-if="row.sort != 0 && row.module_type != 'v3_top_recommend'">
              <el-button type="text" size="small" @click="updateSort(row.id)">
                <div>{{ row.sort }}</div>
              </el-button>
            </template>
            <template v-else>
              <div>{{ row.sort }}</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="{ row }">
            <template v-if="row.sort != 0">
              <div>
                <template v-if="row.module_type != 'v3_top_recommend'">
                  <span v-if="row.status == 1" style="color: #67c23a"><i class="el-icon-circle-check"></i> 已发布</span>
                  <span v-else style="color: #909399"><i class="el-icon-circle-close"></i> 未发布</span>
                  <el-button type="text" size="small" style="margin-left: 5px"
                             @click=" row.status == 1 ? updateOnline(row.id, 'offline') : updateOnline(row.id, 'online')">
                    {{ row.status == 1 ? "下架" : "发布" }}
                  </el-button>
                </template>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <template v-if="row.sort != 0">
              <template v-if="row.module_type == 'banner1'">
                <el-button type="primary" size="small" @click="gotoBannerList(8)">轮播图配置</el-button>
              </template>
              <template v-if="row.module_type == 'banner2'">
                <el-button type="primary" size="small" @click="gotoBannerList(15)">轮播图配置</el-button>
                <el-button type="primary" size="small" @click="gotoModuleImgInfo(row.id)">模块头图配置</el-button>
              </template>
              <template v-if="row.module_type == 'quick_access'">
                <el-button type="primary" size="small" @click="gotoProductCategory()">分类配置</el-button>
              </template>
              <template v-if="row.module_type == 'coupon_info'">
                <el-button type="primary" size="small" @click="gotoCouponList(row.id)">优惠券配置</el-button>
              </template>
              <template v-if="row.module_type == 'flash_sale'">
                <el-button type="primary" size="small" @click="gotoFlashSaleList(row.id)">秒杀配置</el-button>
                <el-button type="primary" size="small" @click="gotoModuleImgInfo(row.id)">模块头图配置</el-button>
              </template>
              <template v-if="row.module_type == 'product_info'">
                <el-button type="primary" size="small" @click="gotoModuleImgInfo(row.id)">版块头图配置</el-button>
                <el-button type="primary" size="small" @click="gotoProductList(row.id)">商品配置</el-button>
                <el-button type="danger" size="small" @click="deleteModule(row.id)">删除</el-button>
              </template>
              <template v-if="row.module_type == 'v3_top_recommend'">
                <el-button type="primary" size="small" @click="gotoModuleInfoTitle(row.id)">修改标题</el-button>
                <el-button type="primary" size="small" @click="gotoProductList(row.id)">商品配置</el-button>
              </template>
            </template>

            <template v-if="row.sort == 0">
              <el-button type="primary" size="small" @click="gotoModuleImgInfo(row.id)">模块头图配置</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top:10px">
        <el-pagination background @current-change="getList" :current-page.sync="query.page"
                       :page-size="query.limit"
                       layout="total, prev, pager, next, jumper" :total="listTotal">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  moduleList, updateSort, updateOnline, deleteModule
} from "@/api/mall";

export default {
  data: function () {
    return {
      listData: [],
      listLoading: false,
      listTotal: 0,
      query: {
        limit: 20,
        page: 1
      }
    }
  },
  created: function () {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      moduleList(this.query).then(response => {
        this.listData = response.data.list
        this.listLoading = false;
        this.listTotal = response.data.total;
      });
    },
    createModule(){
      this.$router.push({
        path: "/mall/home/v2/moduleInfo",
        query: {}
      });
    },
    deleteModule(id){
      this.$confirm('此操作将删除版块信息，是否确认操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        deleteModule({id}).then(response => {
          this.listLoading = false;
          if (response.code == 1) {
            this.getList();
            this.$message({
              showClose: true,
              duration: 6000,
              message: '删除成功',
              type: 'success'
            });
          }
        });
      }).catch(() => {

      });
    },
    gotoModuleInfoTitle(id) {
      this.$router.push({
        path: "/mall/home/v2/moduleInfoTitle",
        query: {
          id: id,
          admin_id: this.$route.query.admin_id,
          admin_name: this.$route.query.admin_name
        }
      });
    },
    gotoModuleImgInfo(id) {
      this.$router.push({
        path: "/mall/home/v2/moduleImgInfo",
        query: {
          id: id,
          admin_id: this.$route.query.admin_id,
          admin_name: this.$route.query.admin_name
        }
      });
    },
    gotoProductList(module_id) {
      this.$router.push({
        path: "/mall/home/v2/productList",
        query: {
          module_id: module_id,
          admin_id: this.$route.query.admin_id,
          admin_name: this.$route.query.admin_name
        }
      });
    },
    gotoFlashSaleList(module_id) {
      this.$router.push({
        path: "/mall/home/v2/flashSaleList",
        query: {
          module_id: module_id,
          admin_id: this.$route.query.admin_id,
          admin_name: this.$route.query.admin_name
        }
      });
    },
    gotoCouponList(module_id) {
      this.$router.push({
        path: "/mall/home/v2/couponList",
        query: {
          module_id: module_id,
          admin_id: this.$route.query.admin_id,
          admin_name: this.$route.query.admin_name
        }
      });
    },
    gotoProductCategory() {
      this.$router.push({
        path: "/mall/productCategory",
        query: {
          admin_id: this.$route.query.admin_id,
          admin_name: this.$route.query.admin_name
        }
      });
    },
    gotoBannerList(id) {
      this.$router.push({
        path: "/banner/list",
        query: {
          banner_item_id: id,
          admin_id: this.$route.query.admin_id,
          admin_name: this.$route.query.admin_name
        }
      });
    },
    updateSort(id) {
      this.$prompt("请输入排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputErrorMessage: "格式不正确",
      })
          .then(({value}) => {
            updateSort({
              id: id,
              sort: value,
            }).then((response) => {
              if (response.status == 2000) {
                this.getList();
                this.$message({
                  showClose: true,
                  message: "设置成功",
                  type: "success",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            });
          })
          .catch(() => {
          });
    },
    updateAssist(id) {
      this.$router.push({
        path: "/activity/custom/info",
        query: {type: 'update', id: id}
      });
    },
    homeConfig() {
      this.$router.push({
        path: "/mall/home/v2/config",
        query: {
          admin_id: this.$route.query.admin_id,
          admin_name: this.$route.query.admin_name
        }
      });
    },
    updateOnline(id, type) {
      this.listLoading = true;
      updateOnline({id, type}).then(response => {
        this.listLoading = false;
        if (response.code == 1) {
          this.getList();
          this.$message({
            showClose: true,
            duration: 6000,
            message: '修改成功',
            type: 'success'
          });
        }
      });
    }
  },
}
</script>
<style>
.el-button {
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>